module.exports = __webpack_public_path__ + "img/download.fa2d12a3.svg";